import {Brand, BrandCode} from '../types'

// eslint-disable-next-line @typescript-eslint/no-var-requires
export const brands = require('../../../../../config/brands') as Record<
  BrandCode,
  Brand
>

export const defaultBrand = brands.vio
